import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import donationReducer from './slices/donation';
import projectReducer from './slices/projects';
import charityReducer from './slices/charity';
import causeReducer from './slices/cause';
import giftCardReducer from './slices/giftCard';
import voucherReducer from './slices/voucher';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['giftCard'],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  donation: donationReducer,
  project: projectReducer,
  charity: charityReducer,
  cause: causeReducer,
  giftCard: giftCardReducer,
  voucher: voucherReducer,
});

export { rootPersistConfig, rootReducer };
